var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4747 4.93962V8.80214C14.4747 11.1121 13.1547 12.1021 11.1747 12.1021H4.58222C4.24472 12.1021 3.92222 12.0722 3.62222 12.0047C3.43472 11.9747 3.25473 11.9222 3.08973 11.8622C1.96473 11.4422 1.28223 10.4671 1.28223 8.80214V4.93962C1.28223 2.62962 2.60222 1.63965 4.58222 1.63965H11.1747C12.8547 1.63965 14.0622 2.35214 14.3847 3.97964C14.4372 4.27964 14.4747 4.58712 14.4747 4.93962Z",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7255 7.18947V11.052C16.7255 13.362 15.4056 14.352 13.4256 14.352H6.83305C6.27805 14.352 5.77555 14.277 5.34055 14.112C4.44805 13.782 3.84055 13.0995 3.62305 12.0045C3.92305 12.072 4.24555 12.102 4.58305 12.102H11.1756C13.1556 12.102 14.4755 11.112 14.4755 8.80199V4.93947C14.4755 4.58697 14.4456 4.27199 14.3856 3.97949C15.8106 4.27949 16.7255 5.28447 16.7255 7.18947Z",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87357 8.85455C8.96709 8.85455 9.85358 7.96807 9.85358 6.87454C9.85358 5.78102 8.96709 4.89453 7.87357 4.89453C6.78004 4.89453 5.89355 5.78102 5.89355 6.87454C5.89355 7.96807 6.78004 8.85455 7.87357 8.85455Z",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58496 5.22461V8.52463",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.166 5.22461V8.52463",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryIcon);
export default __webpack_public_path__ + "static/media/salary_icon.f94731015adcc6b9260ebe1b1f0e0eda.svg";
export { ForwardRef as ReactComponent };